import { Component } from '@angular/core';

/**
 * Root component for Angular rendering process
 *
 * @export
 * @class AppComponent
 */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent { }
